import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M6.66634 9.81641C6.66634 9.35617 7.03944 8.98307 7.49967 8.98307H12.4997C12.9599 8.98307 13.333 9.35617 13.333 9.81641C13.333 10.2766 12.9599 10.6497 12.4997 10.6497H7.49967C7.03944 10.6497 6.66634 10.2766 6.66634 9.81641Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M7.49967 12.3164C7.03944 12.3164 6.66634 12.6895 6.66634 13.1497C6.66634 13.61 7.03944 13.9831 7.49967 13.9831H10.833C11.2932 13.9831 11.6663 13.61 11.6663 13.1497C11.6663 12.6895 11.2932 12.3164 10.833 12.3164H7.49967Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.9165 3.14974C12.5364 2.64372 11.9313 2.31641 11.2497 2.31641H8.74967C8.06808 2.31641 7.46294 2.64372 7.08286 3.14974H5.83301C4.4523 3.14974 3.33301 4.26903 3.33301 5.64974V15.6497C3.33301 17.0304 4.4523 18.1497 5.83301 18.1497H14.1663C15.5471 18.1497 16.6663 17.0305 16.6663 15.6497V5.64974C16.6663 4.26903 15.5471 3.14974 14.1663 3.14974H12.9165ZM8.33301 4.39974C8.33301 4.16962 8.51956 3.98307 8.74967 3.98307H11.2497C11.4798 3.98307 11.6663 4.16962 11.6663 4.39974C11.6663 4.62986 11.4798 4.81641 11.2497 4.81641H8.74967C8.51956 4.81641 8.33301 4.62986 8.33301 4.39974ZM6.70802 4.81641H5.83301C5.37277 4.81641 4.99967 5.1895 4.99967 5.64974V15.6497C4.99967 16.11 5.37277 16.4831 5.83301 16.4831H14.1663C14.6266 16.4831 14.9997 16.11 14.9997 15.6497V5.64974C14.9997 5.1895 14.6266 4.81641 14.1663 4.81641H13.2913C13.0983 5.76734 12.2576 6.48307 11.2497 6.48307H8.74967C7.74178 6.48307 6.90104 5.76734 6.70802 4.81641Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}